export default "__VITE_ASSET__a1c2280f__"